import {
    createFrontendPlugin,
    FrontendPlugin,
    PageBlueprint,
} from "@backstage/frontend-plugin-api";
import { EntityCardBlueprint } from "@backstage/plugin-catalog-react/alpha";
import { rootRouteRef } from "@internal/backstage-plugin-constellation-react";
import { RiBubbleChartLine } from "@remixicon/react";

/**
 * Full-page constellation graph showing all catalog entities.
 * Registered at /constellation.
 */
const constellationPage = PageBlueprint.make({
    params: {
        path: "/constellation",
        title: "Constellation",
        routeRef: rootRouteRef,
        loader: () =>
            import("@internal/backstage-plugin-constellation-react").then(m => (
                <m.ConstellationFullGraphPage />
            )),
    },
});

/**
 * Entity card extension for the constellation graph.
 *
 * Renders an interactive force-directed graph of the current entity's
 * relationships on the entity overview page. Includes a toggle to switch
 * between the constellation view and the built-in tree diagram.
 *
 * Shown on all entity kinds — every entity has relations worth visualizing.
 */
const constellationEntityCard = EntityCardBlueprint.make({
    name: "constellation-graph",
    params: {
        type: "info",
        loader: () =>
            import("@internal/backstage-plugin-constellation-react").then(m => (
                <m.ConstellationGraphCard />
            )),
    },
});

/**
 * The Constellation plugin provides an interactive force-directed
 * graph visualization for Backstage entity relationships, inspired by
 * Obsidian's graph view.
 */
export const constellationPlugin: FrontendPlugin = createFrontendPlugin({
    pluginId: "constellation",
    title: "Constellation",
    icon: <RiBubbleChartLine />,
    info: {
        packageJson: () => import("../package.json"),
    },
    routes: {
        constellation: rootRouteRef,
    },
    extensions: [constellationPage, constellationEntityCard],
});

export default constellationPlugin;
